import React from "react";
import "./App.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Route, Switch } from "react-router-dom";
import Home from "./components/Home";
import Contact from "./components/Contact";
import Services from "./components/Services";
import About from "./components/About";
import Portfolio from "./components/Portfolio";

const theme = createTheme({
  typography: {
    fontFamily: {
      fontFamily: "Montserrat",
    },
  },
});

function App() {

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Switch>
         <Route exact path="/contact-us" component={Contact} />
         <Route exact path="/our-portfolio" component={Portfolio} />
         <Route exact path="/our-services" component={Services} />
         <Route exact path="/aboutus" component={About} />
         <Route exact path="/" component={Home} />
        </Switch>
      </div>
    </ThemeProvider>
  );
}

export default App;
